import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ModalConnectionComponent extends Vue {

    @Prop() error!: Error;
}
